import React from "react";
import { Card } from "@mui/material";
import CategoryButton from "./CategoryButton";
import FavoriteIcon from "@mui/icons-material/Favorite";
import MuseumIcon from "@mui/icons-material/Museum";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ForestIcon from "@mui/icons-material/Forest";
//import EngineeringIcon from "@mui/icons-material/Engineering";
import SportsHandballIcon from '@mui/icons-material/SportsHandball';
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import FestivalIcon from '@mui/icons-material/Festival';

const categories = [
  { icon: <FavoriteIcon sx={{ color: "white" }} />, label: "서울형키즈", color: "#00AEEF", is_blank:true,  link: "/find?category_id=1" },
  { icon: <MuseumIcon sx={{ color: "white" }} />, label: "전시/박물관", color: "#C13CFF", is_blank:false, link: "/find?category_id=2" },
  { icon: <TheaterComedyIcon sx={{ color: "white" }} />, label: "문화센터", color: "#00BFA5", is_blank:false, link: "/culture" },
  { icon: <MenuBookIcon sx={{ color: "white" }} />, label: "도서관", color: "#FF3D57", is_blank:false, link: "/find?category_id=3" },
  { icon: <SportsHandballIcon sx={{ color: "white" }} />, label: "체육관", color: "#FF3D57", is_blank:false, link: "/find?category_id=6" },
  { icon: <FamilyRestroomIcon sx={{ color: "white" }} />, label: "육아지원센터", color: "#007B00", is_blank:false, link: "/find?category_id=4" },
  { icon: <FestivalIcon sx={{ color: "white" }} />, label: "축제", color: "#007BFF", is_blank:false, link: "/find?category_id=7" },
  { icon: <ForestIcon sx={{ color: "white" }} />, label: "공원/휴양림", color: "#44bf1b", is_blank:false, link: "/find?category_id=8" }
];

const CategoryList = () => {
  return (
    <Card  sx={{ display: "flex", justifyContent: "center", gap: 0.2, mt: 1, flexWrap:"wrap",p:1, pt:2.5, borderRadius:2 }}>
      {categories.map((category, index) => (
        <CategoryButton key={index} {...category} />
      ))}
    </Card>
  );
};

export default CategoryList;
